import React from 'react';
import './Waves.css';

import WavesSVG from '../../Assets/decals/Waves.svg'

const Waves = () => {
    return ( 
        <div className='Waves'>
            <img className='WavesSVG' src={WavesSVG} alt="Waves" />
        </div>
     );
}
 
export default Waves;